/**
 * Global-config lookup for the palbe/next surfaces that run inside the
 * SERVER module graph (pbServer, handleAuthCallback) — the graph the root
 * layout's `import './palbe.gen'` configures.
 *
 * This module reaches `../internal.js` (and therefore the whole runtime
 * graph: livekit-client + the MLS WASM loader) on purpose — those surfaces
 * build a real runtime anyway. It is kept OUT of ./shared.ts so the
 * middleware entry, which must stay Edge-lean, never pulls it in.
 */
import type { PalbeConfig } from '../config.js';
import { BackendError } from '../errors.js';
import { getRuntime } from '../internal.js';

/**
 * Global config with a surface-specific guided error when absent. Each
 * surface names the import location that configures ITS module graph.
 */
export function requireGlobalConfig(hint: string): PalbeConfig {
  try {
    return getRuntime().config;
  } catch {
    throw new BackendError('notConfigured', {
      code: 'not_configured',
      message: `Palbe is not configured in this module graph. Run 'palbase link' and ${hint}`,
    });
  }
}
